import { generateKitInfo } from '~api/KitsAPI/utils/kitsReducer';
import { IKitTypes, IPGKitItem, IPGKitItems, IMappedKitItem } from '~api/KitsAPI/utils/IKits';

const emptyKitInfo = { kitName: '', kitProductCodes: [], kitItems: [] };

const getMedia = (media: string | string[]) => (Array.isArray(media) ? media[0] : media);

const getFirstFoundMedia = (item: IMappedKitItem | IPGKitItem) =>
    getMedia(item['sku.IMAGE_S']) ||
    getMedia(item['sku.IMAGE_MEDIUM']) ||
    getMedia(item['prod.MEDIUM_IMAGE']) ||
    getMedia(item['sku.MEDIUM_IMAGE']) ||
    getMedia(item['prod.THUMBNAIL_IMAGE']) ||
    getMedia(item['prod.SMALL_IMAGE']) ||
    getMedia(item['sku.THUMBNAIL_IMAGE']) ||
    getMedia(item['sku.LARGE_IMAGE']) ||
    getMedia(item['sku.SMALL_IMAGE']);

const kitDiscountMapper = (item: IMappedKitItem | IPGKitItem) => {
    const discountPrice = item?.DISCOUNT_AMOUNT
        ? item?.UNIT_PRICE + item?.DISCOUNT_AMOUNT
        : item?.discountedAppliedPrice ?? item?.basePrice;
    const appliedPrice = item?.APPLIED_PRICE ?? discountPrice * (item?.ITEM_QUANTITY ?? 1);

    return {
        appliedPrice,
        discountPercent: item?.DISCOUNT_PCT || item?.discountPercent,
        discountedUnitPrice: discountPrice,
        discountedUnitPriceWithTax: item?.DISCOUNT_PRICE || discountPrice,
        appliedPriceWithTax: discountPrice
    };
};

export const getKitTypeData = (item: IPGKitItems) => {
    const engravedSku = (item.engraving?.engraved_sku as IPGKitItem) || {};
    const { kitProductCodes, kitName, kitItems } = item.items.reduce(generateKitInfo, emptyKitInfo);
    const defaultThumb = getFirstFoundMedia(item) || getFirstFoundMedia(item.items[0]);
    const defaultProductCode = item.items[0]['prod.FAMILY_CODE'];

    const isUKit =
        item.COLLECTION_TYPE === IKitTypes.ukit && item.COLLECTION_SUBTYPE !== 'EL_DW_DRAMMING';
    const hasEngraving = !!item.hasEngraving;
    const type = isUKit ? IKitTypes.ukit : hasEngraving ? IKitTypes.engraving : IKitTypes.default;
    const qty = item.CART_QUANTITY || item.ITEM_QUANTITY;

    const kitTypes = {
        UKIT: {
            name: kitName,
            thumb: defaultThumb.replace(defaultProductCode, kitProductCodes.join('_'))
        },
        engraving: {
            name: engravedSku?.['prod.PROD_RGN_NAME'],
            description: engravedSku?.['prod.PROD_RGN_SUBHEADING'],
            quantity: engravedSku?.ITEM_QUANTITY,
            thumb: getFirstFoundMedia(engravedSku),
            shade: engravedSku?.['sku.SHADENAME'],
            shadeCode: engravedSku?.['sku.HEX_VALUE'] || engravedSku?.['sku.HEX_VALUE_STRING'],
            price: engravedSku?.UNIT_PRICE,
            size: engravedSku?.['sku.PRODUCT_SIZE'],
            url: engravedSku?.['prod.url'],
            ...kitDiscountMapper(engravedSku)
        },
        default: {
            name: item['prod.PROD_RGN_NAME'],
            thumb: defaultThumb
        }
    };

    return {
        kitItems,
        price: item.basePrice,
        quantity: qty === undefined || qty === null ? 1 : qty,
        size: item?.['sku.PRODUCT_SIZE'] || '',
        shade: item?.['sku.SHADENAME'] || '',
        shadeCode: item?.['sku.HEX_VALUE'] || item?.['sku.HEX_VALUE_STRING'] || '',
        url: item?.['prod.url'] || '',
        description: item?.['prod.PROD_RGN_SUBHEADING'] || '',
        ...kitDiscountMapper(item),
        ...kitTypes[type]
    };
};
